module.exports = __webpack_public_path__ + "img/end_bg.055f2059.jpg";